module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Chat")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Status"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "btn-toggle"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm active",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-square text-green"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-square text-red"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body chat id-chat-box"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "online",
    attrs: {
      "src": require("admin-lte/dist/img/user4-128x128.jpg"),
      "alt": "user image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_c('a', {
    staticClass: "name",
    attrs: {
      "href": "#"
    }
  }, [_c('small', {
    staticClass: "text-muted pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2:15")]), _vm._v("\n          Mike Doe\n        ")]), _vm._v("\n        I would like to meet you to discuss the latest news about\n        the arrival of the new theme. They say it is going to be one the\n        best themes on the market\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "attachment"
  }, [_c('h4', [_vm._v("Attachments:")]), _vm._v(" "), _c('p', {
    staticClass: "filename"
  }, [_vm._v("\n          Theme-thumbnail-image.jpg\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Open")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "offline",
    attrs: {
      "src": require("admin-lte/dist/img/user3-128x128.jpg"),
      "alt": "user image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_c('a', {
    staticClass: "name",
    attrs: {
      "href": "#"
    }
  }, [_c('small', {
    staticClass: "text-muted pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 5:15")]), _vm._v("\n          Alexander Pierce\n        ")]), _vm._v("\n        I would like to meet you to discuss the latest news about\n        the arrival of the new theme. They say it is going to be one the\n        best themes on the market\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "offline",
    attrs: {
      "src": require("admin-lte/dist/img/user2-160x160.jpg"),
      "alt": "user image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_c('a', {
    staticClass: "name",
    attrs: {
      "href": "#"
    }
  }, [_c('small', {
    staticClass: "text-muted pull-right"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 5:30")]), _vm._v("\n          Susan Doe\n        ")]), _vm._v("\n        I would like to meet you to discuss the latest news about\n        the arrival of the new theme. They say it is going to be one the\n        best themes on the market\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Type message..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10abebda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VAChatBox.vue
// module id = 672
// module chunks = 0